import { CoreTypography, CoreTypographyVariant } from '@ingenico/react-ui/core-typography';
import { Box, Checkbox } from '@mui/material';
import type { ReactElement } from 'react';

import { ListViewItem } from '@ingenico/react-ui/datagrid';
import classNames from 'classnames';
import type { ModuleItemField } from '../../../domain/models/snapshot.model';
import { DownloadLazyLogo } from '../../download-lazy-logo/DownloadLazyLogo.ctrl';
import styles from './ModuleItem.module.scss';

export interface ModuleItemProps extends ModuleItemField {
  readonly onClick: () => void;
  readonly isSelected: boolean;
}
export function ModuleItem({ logoAssetId, name, module, version, onClick, isSelected }: ModuleItemProps): ReactElement {
  return (
    <div className={classNames(styles.container)} onClick={() => onClick()}>
      <Box className={classNames(styles.leftContainer)}>
        <Checkbox checked={isSelected} />
        <Box className={styles.configurationLogo}>
          {logoAssetId && <DownloadLazyLogo height={30} width={30} logoAssetId={logoAssetId} name={name} />}
          <ListViewItem className={styles.configurationLogoText} primaryText={name} />
        </Box>
      </Box>

      <Box className={styles.moduleTextContainer}>
        <Box className={styles.moduleTextInfo}>
          <>
            <CoreTypography
              customClassName={styles.moduleTextInfo__fullName}
              showTooltip
              variant={CoreTypographyVariant.Body02Medium}
            >
              {module}
            </CoreTypography>
            <CoreTypography
              customClassName={styles.moduleTextInfo__username}
              showTooltip
              variant={CoreTypographyVariant.Body02Regular}
            >
              {version}
            </CoreTypography>
          </>
        </Box>
      </Box>
    </div>
  );
}
